import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '../Common/Button';

// Types.
import { SimpleUser } from '../../types/customer';
import { hideUpdateInfo } from './MyInfo';

type customerDetails = {
  customer: SimpleUser;
};
/**
 * The details accordian component. Used to show contracts and user details.
 */
const LoggedinUserDetails: React.FunctionComponent<customerDetails> = (props: customerDetails) => {
  const { t } = useTranslation();
  const { customer } = props;

  return (
    <div className="mandate">
      <div className="accordion-padding">
        <p>{t('myInfo:customerInfo.ingressLoginChange')}</p>
        <div className="name detail col-6">
          <label>{t('common:general.name')}</label>
          <p>{customer.loginName}</p>
        </div>
        <div className="email detail col-6">
          <label> {t('myInfo:customerInfo.loggedInUser')} </label>
          <p>{customer.loginEmail}</p>
          {!hideUpdateInfo && <Button link={`${import.meta.env.VITE_IAM_UPDATE_LOGIN}`}>{t('myInfo:customerInfo.updateLogin')}</Button>}
        </div>
      </div>
    </div>
  );
};

export default LoggedinUserDetails;
